import React, { Fragment } from "react";
import HEAD from "./resources/next-banner.jpg";

export const AppBar = () => {
  return (
    <Fragment>
      <div
        className="p-4"
        style={{ backgroundImage: `url(${HEAD})` }}
      >
        <h3 style={{ color: "white" }}>Tracking</h3>
      </div>
    </Fragment>
  );
};
